export const LOGIN = 'LOGIN';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CLEAR_ALERTS = 'CLEAR_ALERTS'
export const IS_FETCHING_LOGIN = 'IS_FETCHING_LOGIN';
export const IS_FETCHING_FORGOT_PASSWORD = 'IS_FETCHING_FORGOT_PASSWORD';
export const RE_SEND_FORGOT_PASSWORD = 'RE_SEND_FORGOT_PASSWORD';